module.exports = __webpack_public_path__ + "img/horizontal_1_1_8003.74cf7574.png";